import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users as UsersIcon, ArrowRight } from "lucide-react";
import { api } from "../../lib/api";

export default function Patients() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/doctor/patients").then((r) => setList(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6" data-testid="doc-patients">
      <div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-teal-400">◖ patients</div>
        <h1 className="mt-2 text-3xl font-light tracking-tight">Your patients</h1>
        <p className="text-sm text-mb-fg2 mt-1">Distinct patients you have seen.</p>
      </div>
      <div className="rounded-xl border border-mb-border bg-mb-surface">
        {loading ? (
          <div className="px-6 py-10 text-sm text-mb-fg2 text-center">Loading…</div>
        ) : list.length === 0 ? (
          <div className="px-6 py-10 text-sm text-mb-fg2 text-center" data-testid="doc-patients-empty">No patients yet.</div>
        ) : (
          <ul className="divide-y divide-mb-border">
            {list.map((p) => (
              <li key={p.id} className="px-5 py-4 flex items-center gap-4" data-testid={`patient-row-${p.id}`}>
                <div className="h-10 w-10 rounded-full bg-teal-500/10 text-teal-300 flex items-center justify-center text-sm font-medium">
                  {(p.full_name || "?").split(" ").map((s) => s[0]).slice(0, 2).join("")}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm text-white truncate">{p.full_name}</div>
                  <div className="text-xs text-mb-fg2 truncate">{p.email}</div>
                </div>
                <div className="text-right text-xs text-mb-fg2 hidden sm:block">
                  <div>{p.visit_count} visit{p.visit_count !== 1 ? "s" : ""}</div>
                  <div>last: {p.last_visit ? new Date(p.last_visit).toLocaleDateString() : "—"}</div>
                </div>
                <Link to={`/doctor/patients/${p.id}`} data-testid={`patient-view-${p.id}`}
                  className="text-sm text-teal-400 hover:text-teal-300 inline-flex items-center gap-1">
                  History <ArrowRight className="h-3 w-3" />
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
